import React from 'react'

export default function EmployeeCardWrap(props) {
  return (
    <section className="hds-container employee-card-wrapper">
      <div className="hds-section">
        <div className={`grid md:grid-cols-2 lg:grid-cols-4 gap-4`}>
          {props.children}
        </div>
      </div>
    </section>
  )
}
